// extracted by mini-css-extract-plugin
module.exports = {"omnisearchSmall":"styles_omnisearchSmall__7RUfe","omnisearchLarge":"styles_omnisearchLarge__lXNdU"};